.ErrorBoundaryActions {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--space-sm);
}
